<p-confirmDialog />

<div class="page-title">
  Creditar Glampoints
  <span *ngIf="action">— {{ action.name }} ({{ action.points }} pts)</span>
</div>

<p-card>
  <p class="warn" *ngIf="inactive">
    Esta ação não está ativa (já gerada ou inativa) — não é possível creditar.
  </p>

  <form [formGroup]="form" class="form-b4a" (submit)="confirmCredit()">
    <span class="p-float-label full-w">
      <textarea
        pInputTextarea
        id="emails"
        rows="4"
        formControlName="emails"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('emails') }"
        (input)="parseEmails()"
      ></textarea>
      <label for="emails">E-mails (um por linha ou separados por vírgula) *</label>
    </span>
    <small class="error full-w" *ngIf="invalidControl('emails')">
      Informe ao menos um e-mail.
    </small>
    <small class="ok full-w" *ngIf="validEmails.length">
      {{ validEmails.length }} e-mail(s) com formato válido.
    </small>
    <small class="warn full-w" *ngIf="invalidEmails.length">
      {{ invalidEmails.length }} com formato inválido (serão ignorados):
      {{ invalidEmails.join(', ') }}
    </small>

    <ng-container *ngIf="preview">
      <small class="ok full-w" *ngIf="eligibleEmails.length">
        ✔ {{ eligibleEmails.length }} e-mail(s) encontrado(s) e apto(s) a receber.
      </small>
      <small class="error full-w" *ngIf="previewNotFound.length">
        ✖ {{ previewNotFound.length }} não encontrado(s) na base (confira a digitação):
        {{ previewNotFound.join(', ') }}
      </small>
      <small class="warn full-w" *ngIf="previewNoSubscription.length">
        ⚠ {{ previewNoSubscription.length }} sem assinatura Glambox ativa:
        {{ previewNoSubscription.join(', ') }}
      </small>
      <small class="warn full-w" *ngIf="previewDuplicated.length">
        ⚠ {{ previewDuplicated.length }} já creditado(s) nesta ação:
        {{ previewDuplicated.join(', ') }}
      </small>
      <small class="error full-w" *ngIf="previewErrors.length">
        ✖ {{ previewErrors.length }} com erro na consulta (tente validar de novo):
        {{ previewErrors.join(', ') }}
      </small>
    </ng-container>
    <small class="warn full-w" *ngIf="!preview && validEmails.length">
      Valide os e-mails contra a base antes de creditar.
    </small>

    <div class="buttons">
      <p-button
        label="Validar e-mails"
        icon="pi pi-check-circle"
        severity="secondary"
        type="button"
        [disabled]="!canValidate"
        (onClick)="validateEmails()"
      />
      <p-button
        [label]="creditLabel"
        icon="pi pi-send"
        type="submit"
        [disabled]="!canSubmit"
      />
    </div>
  </form>
</p-card>
